import { render, staticRenderFns } from "./Symbols.vue?vue&type=template&id=67f33c33&scoped=true"
import script from "./Symbols.vue?vue&type=script&lang=js"
export * from "./Symbols.vue?vue&type=script&lang=js"
import style0 from "./Symbols.vue?vue&type=style&index=0&id=67f33c33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f33c33",
  null
  
)

export default component.exports